// this is collection for same model types used in resources object
// i.e. .tasks = colleciton
// project = collection

import ModelEntity from "../../model2/model-entity";
import Resources from "../resources";
import {DeltaEventMethodType} from "../../gd/manager/delta-handler/types";

const debug: boolean = false
// const debug: string = "ResourcesCollectionProto"

export default class ResourcesCollectionProto {

    private resources: Resources
    private MODEL_CLASS: any
    private options: any
    private _models: any[]
    private _byId: any

    constructor(resources:Resources, data: any[], ModelClass:any = null, options:any={}) {
        this.resources      = resources     // link to resources object

        this.MODEL_CLASS    = ModelClass
        this.options        = options       // params passed to anynew model created
        this._models        = []

        this.reset(data, this.options)
    }

    get(id: string) {
        return this._byId[id]
    }

    get items() {return this._models}
    get models() {return this._models}

    get isEmpty() {
        return !this._models || this._models.length < 1
    }

    get length(): number {return this._models ? this._models.length : 0}


    // resetFromData(models: any[], options:any={}): void {
    //
    //     // remove old models
    //
    //     this.removeAll()
    //     this.options    = options
    //
    //     this._models    = []
    //     this._byId      = {}
    //
    //
    //
    //     _.map(models, (modelData) => {
    //         if (modelData !== null) {
    //             if (this.MODEL_CLASS) {
    //                 this.add(new this.MODEL_CLASS(modelData, options))
    //
    //             } else {
    //
    //                 this.add(modelData);
    //             }
    //         }
    //     })
    //
    // }


    reset(models: any[], options:any={}): void {

        // remove old models

        this.removeAll()
        this.options    = options

        this._models    = []
        this._byId      = {}



            _.map(models, (modelData) => {
                if (modelData !== null) {
                    if (this.MODEL_CLASS) {
                        this.add(new this.MODEL_CLASS(modelData, options))

                    } else {

                        this.add(modelData);
                    }
                }
            })

    }

    add(model: ModelEntity): void {
        // make sure we do no add same model twice

        if (this.get(model?.id)) {
            console.log("trying to add model twice - so remove old and replace", model)
            this.remove(model.id)
        }

        this._models.push(model)
        this._byId[model?.id] = model
        this.resources._ridMap[model?.rid] = model // add to resources map

    }

    addFromJson(modelData:JSONObject):void {
        this.add(new this.MODEL_CLASS(modelData, this.options))
    }

    removeAll() {
        this._models.map((model:ModelEntity)=>{
            this.remove(model.id)
        })
    }

    removeMany(ids: string[]): any[] {

        let allRemovedModels : ModelEntity[] = []

        _.map(ids, (id:string)=>{
            const removedModels = this.remove(id)
            allRemovedModels = allRemovedModels.concat(removedModels)
        })

        return allRemovedModels
    }

    remove(id: string): any[] {
        delete this._byId[id]
        const removedModels: any[] = _.remove(this._models, model=>model.id === id)

        debug && console.log(debug, 'remove', id, removedModels)

        if (removedModels) {
            _.map(removedModels, removedModel=>{
                delete this.resources._ridMap[removedModel.rid]
            })
        }

        return removedModels
    }

    replace(id: string, model: any): void {
        // find index of model to replace
        const index: number = _.findIndex(this._models, model=>model.id === id)

        // replace model at index
        this._models.splice(index, 1, model)

        delete this._byId[id]                       // remove old model
        this._byId[model.id] = model                // add new model
        this.resources._ridMap[model.rid] = model   // add/replace to/in resources map
    }

    // Delta
    applyDelta(method: DeltaEventMethodType, data: any, expense?:any): void {

        debug && console.log(debug, "apply delta")

        const itemId = data.id || expense?.id

        switch (method) {
            case DeltaEventMethodType.DELETE:
                this.remove(itemId);
                break

            case DeltaEventMethodType.NEW:
                debug && console.log("    - add MODEL before Add size=", this.length)
                this.add(new this.MODEL_CLASS(data, this.options));
                debug && console.log("    - after Add size=", this.length)
                break

            case DeltaEventMethodType.DELTA:
                // console.orange("here")
                // console.log(itemId)
                const model = this.get(itemId)
                if (model) model.applyDelta(data)
                break
        }
    }

    // used when we want to store sort position within collection itself
    // i.e. manual sorting without sortPosition field
    reorderByIds(orderedIds: string[]) {
        const result: any[] = []
        _.map(orderedIds, (id: string)=>{
            result.push(this.get(id))
        })
        this._models = result;
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = []): void {

        // if arrayOfIds is null - berem vse
        // arrayOfFields = [FIELD3_Instance, FIELD3_Instance]

        // HEADER field.fieldID ? or something else ? field.CSV_FIELD_NAME ?

        // foreach ....
        // FIELD.getCSVVALUE(MODEL ? value ?) .... akkuratno

    }

    importFromCSV(data: any, fieldCollection: any): void {
        // USER DATA [array of {}]
        // FIELDS MAPPING user columns -> fields [FIELDS COLLECTION]
        //      CUSTOM FIELDS

        // DATA NORMALIZING USERDATA -> GOODDATA field.normilizeCSVValue -> value
        //      tut mogut' bit' errors kot. ne daut import

        // esli vse horosho -> universl import for each collection (Task collection, documents collection , CRM collection)

        // ALL GOOD

    }
}
